import { Card, Typography, Row, Col, Divider } from "antd";
import { dateToString } from "../../../../../utils/formatter";
const { Title, Text } = Typography;

function RegretDetails({ orderDetails }) {
  return (
    <Card
      bordered={false}
      style={{
        width: "100%",
        borderRadius: 8,
        border: "1px solid red",
        marginBottom: 35,
      }}
    >
      <Title level={4} style={{ marginBottom: 24, color: "#ef4444" }}>
        Regret Details
      </Title>

      <Row style={{ marginBottom: 24 }}>
        <Col span={12}>
          <Title level={5}>Rejection Reason</Title>
          <Text style={{ color: "#ef4444", fontWeight: "bold" }}>
            {orderDetails?.orderCancellationReason || "-"}
          </Text>
        </Col>
        <Col span={12}>
          <Title level={5}>Regret Date</Title>
          <Text>{dateToString(orderDetails?.orderRegretDate)}</Text>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Title level={5}>Rejection Remarks</Title>
          <Text>
            {orderDetails?.rejectionRemarks || "-"}
          </Text>
        </Col>
      </Row>

    </Card>
  )
}

export default RegretDetails